///
/// If you make changes to this file you must also make changes to src\app\shared\constants\information-modal.constant.ts
///

import { MAX_AMOUNT_REPLACE } from "./shared.constant";

export const ElectronicPaymentCodeHelpConfig = {
  code: "ElectronicPaymentCodeHelp",
  title: "Encontrá el código de pago electrónico",
  subtitle: "Código de pago electrónico",
  img: "modal__help.png",
  body: "Este código está compuesto por 14 dígitos e identifica tu servicio a abonar. En caso de no localizarlo, por favor comunicate con el ente emisor.",
};

export const InvalidHighAmountHelpConfig = {
  code: "invalidAmount",
  title: "¡ATENCION! MONTO ELEVADO",
  subtitle: "Es posible que alguno de los medios de pago no estén disponibles.",
  img: "",
  body: "",
  footer: "",
};

export const InvalidAmountHelpConfig = {
  code: "invalidAmount",
  title: "¡ATENCION! MONTO EXCEDIDO",
  subtitle: "El importe excede el límite establecido por transacción.",
  subtitleMultiPayments:
    "El importe excede el límite establecido para algunos de los códigos ingresados.",
  img: "",
  body:
    "Podés pagar hasta $" +
    MAX_AMOUNT_REPLACE +
    " y completar el saldo en una nueva operación.",
  bodyMultiPayments: "",
  footer: "Para continuar pagando modificá los importes.",
};

export const ExpiredPaymentHelpConfig = {
  code: "expiredPayment",
  title: "¡ATENCION!",
  subtitle: "",
  img: "",
  body: "El comprobante que estás queriendo abonar se encuentra vencido, solo podrás realizar su pago por transferencia bancaria. Recordá que el pago fuera de término puede estar sujeto a intereses futuros.<br><br>Para mayor información, consultá a tu Administrador.",
  footer: "",
};

export const AddPaymentOnlyPeiHelpConfig = {
  code: "addPaymentOnlyPei",
  title: "¡ATENCION!",
  subtitle: "",
  img: "",
  // body: "Recordá que el pago múltiple solo está habilitado para <b>Tarjeta de débito</b> y <b>Tarjeta de crédito</b>.",
  body: "Recordá que el pago de servicios múltiples solo está habilitado para <b>Tarjeta de débito</b> y <b>Tarjeta de crédito</b>.<br><br>Si deseas adherir tu tarjeta a <b>Débito Automático</b> deberás abonar de a <b>un servicio por vez</b>.",
  footer: "",
};

export const CashPaymentMethodAmountWarningConfig = {
  code: "cashPaymentMethodAmountWarning",
  title: "¡ATENCIÓN!",
  subtitle: "",
  img: "",
  body: "La boleta de pago se emitirá por el monto original informado por la entidad.",
  footer:
    "En caso de ser necesario, podés elegir un monto distinto al momento de abonar.",
};

export const InvalidPaymentAmountHelpConfig = {
  code: "invalidExceededContractAmountPayment",
  title: "¡ATENCION!",
  subtitle:
    "El importe excede el límite de compra dispuesto por este medio de pago.",
  img: "",
  body: "Podrás pagar hasta $" + MAX_AMOUNT_REPLACE + " por transacción.",
  footer: "¿Deseás continuar?",
};

export const InvalidPaymentMethodHelpConfig = {
  code: "invalidPymentMethod",
  title: "¡ATENCION!",
  body: '<font size="+2">Este medio de pago no se encuentra disponible para el pago fuera de término.</font>',
};

export const SecurityCodeHelpConfig = {
  title: "Código de seguridad",
  subtitle: "¿Dónde está el código de seguridad?",
  img: "modal__credit-card.png",
  body: "Este código está formado por los 3 últimos dígitos que se encuentran en el dorso de la tarjeta.",
};

export const InvalidPaymentsMethod = {
  code: "invalidPaymentMethod",
  title: "¡ATENCION!",
  subtitle:
    "Este medio de pago no se encuentra disponible. Contactate con tu entidad para mayor información.",
  img: "",
  body: "",
  footer: "",
};

export const CreditCardOnlyFirstExpiration = {
  code: "invalidPaymentMethod",
  title: "¡ATENCION!",
  subtitle:
    "Este medio de pago sólo se encuentra disponible hasta el primer vencimiento. Contáctate con tu entidad para más información",
  img: "",
  body: "",
  footer: "",
};

export const ReferredProgramInformation = {
  code: "referredProgram",
  title: "Programa de Referidos Plataforma de Soluciones",
  firstLine: "Compartí el código de descuento con tus vecinos y TODOS GANAN!",
  secondLine:
    "Cuando tu vecino use el código, accederá al descuento inmediatamente.",
  thirdLine:
    "Recibirás un mail con la confirmación de su pago y tendrás 1 mes para pagar con descuento tu próxima expensa de esta unidad funcional.",
  validy:
    "Esta promoción es válida para pagos con débito desde el portal ExpensasPagas.Online",
  info: "Ingresá el código de descuento que te compartió tu vecino. Si querés conocer más acerca de nuestro programa de referidos hace click ",
};

export const DirectDebitInfo = {
  code: "directDebitInfo",
  title: "¡ATENCION!",
  // subtitle: "",
  body: "",
  footer: "¿Deseás pagar de todos modos? ",
};

export const TimerQrNotificationInfo = {
  code: "timerQrNotificationInfo",
  title: "¿Seguís ahí?",
  subtitle: "",
  body: "¿Pudiste escanear el QR desde tu billetera?",
  footer: "",
};
